import { render, staticRenderFns } from "./_postControlTabs.vue?vue&type=template&id=448b64fb&scoped=true"
import script from "./_postControlTabs.vue?vue&type=script&lang=js"
export * from "./_postControlTabs.vue?vue&type=script&lang=js"
import style0 from "./_postControlTabs.vue?vue&type=style&index=0&id=448b64fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448b64fb",
  null
  
)

export default component.exports